import { useTranslation } from "react-i18next";
import {
  AlertDialog, AlertDialogAction, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "../ui/alert-dialog";

export const ErrorModal = ({ error, onClose }) => {
  const { t } = useTranslation();
  return (
    <AlertDialog open={!!error} onOpenChange={(o) => !o && onClose()}>
      <AlertDialogContent data-testid="booking-error-modal">
        <AlertDialogHeader>
          <AlertDialogTitle className="heading-upper text-[#144733]">{error?.title || t("Let's fix this")}</AlertDialogTitle>
          <AlertDialogDescription data-testid="booking-error-message">{error?.message}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={onClose} className="bg-[#009900] hover:bg-[#007a00]" data-testid="booking-error-ok-btn">
            {t("Got it")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
